// src/actions/portfolioActions.js

// Action to set active tab
export const setActiveTab = (tab) => ({
    type: 'SET_ACTIVE_TAB',
    payload: tab
});

// Fetch current positions
export const fetchCurrentPositions = (activeTabList) => ({
    type: 'FETCH_CURRENT_POSITIONS',
    payload: { activeTabList }
});

export const fetchCurrentPositionsSuccess = (data) => ({
    type: 'FETCH_CURRENT_POSITIONS_SUCCESS',
    payload: data
});

// Fetch squared off positions
export const fetchSquaredOffPositions = (activeTabList) => ({
    type: 'FETCH_SQUARED_OFF_POSITIONS',
    payload: { activeTabList }
});

export const fetchSquaredOffPositionsSuccess = (data) => ({
    type: 'FETCH_SQUARED_OFF_POSITIONS_SUCCESS',
    payload: data
});

// Market data actions
export const fetchMarketData = (exchangeTokens) => ({
    type: 'FETCH_MARKET_DATA',
    payload: exchangeTokens
});

export const fetchMarketDataSuccess = (data) => ({
    type: 'FETCH_MARKET_DATA_SUCCESS',
    payload: data
});

export const fetchMarketDataFailure = (error) => ({
    type: 'FETCH_MARKET_DATA_FAILURE',
    payload: error
});

// Portfolio summary update
export const updatePortfolioSummary = (summary) => ({
    type: 'UPDATE_PORTFOLIO_SUMMARY',
    payload: summary
});

// Close all orders
export const closeAllOrders = (activeTab, activeTabList) => ({
    type: 'CLOSE_ALL_ORDERS',
    payload: { activeTab, activeTabList }
});

export const closeAllOrdersSuccess = () => ({
    type: 'CLOSE_ALL_ORDERS_SUCCESS'
});

export const clientPositionsGet = () => ({
    type: 'CLIENT_POSITIONS_GET'
});

export const clientPositionsGetSuccess = (data) => ({
    type: 'CLIENT_POSITIONS_GET_SUCCESS',
    payload: data
});

export const closeAllOrdersFailure = (error) => ({
    type: 'CLOSE_ALL_ORDERS_FAILURE',
    payload: error
});

// Generic failure action
export const fetchPortfolioFailure = (error) => ({
    type: 'FETCH_PORTFOLIO_FAILURE',
    payload: error
});